import { useId } from "react";
import { ChevronDown } from "lucide-react";

/**
 * One collapsed group in the menu. The whole panel reads as a short list of
 * rows; a group opens in place only when it is the one a visitor wants, so the
 * drawer stays compact without hiding anything.
 */
export default function MenuAccordion({ icon: Icon, title, hint, open, onToggle, children }) {
  const panelId = useId();

  return (
    <section className="border-b border-black/[0.07] last:border-b-0 dark:border-white/[0.09]">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
        className="flex min-h-[54px] w-full items-center gap-3 px-1.5 text-left"
      >
        <span className="grid h-8 w-8 shrink-0 place-items-center rounded-[10px] border border-black/[0.06] bg-white text-[#171717] dark:border-white/[0.09] dark:bg-[#24221e] dark:text-[#f5f2eb]">
          <Icon aria-hidden="true" className="h-4 w-4" />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block truncate text-[13.5px] font-extrabold tracking-[-0.01em] text-[#171717] dark:text-[#f5f2eb]">
            {title}
          </span>
          {hint ? (
            <span className="mt-0.5 block truncate text-[10.5px] font-semibold text-[#8d8d88] dark:text-[#a9a49a]">
              {hint}
            </span>
          ) : null}
        </span>
        <ChevronDown
          aria-hidden="true"
          className={`h-4 w-4 shrink-0 text-[#8d8d88] transition-transform duration-200 ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open ? (
        <div id={panelId} className="animate-in pb-3 pl-[3.25rem] pr-1 fade-in slide-in-from-top-1 duration-200">
          {children}
        </div>
      ) : null}
    </section>
  );
}